// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c8dcr7{font:var(--ds-font-body-UNSAFE_small,normal 400 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}\n._13mh1pd9 [data-smart-element=Title]{font-weight:var(--ds-font-weight-semibold,600)}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._1bahesu3{justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
